<div class="back-header-container">
  <button mat-icon-button 
          [routerLink]="backLink" 
          (click)="handleClick()"
          aria-label="Back button">
    <mat-icon>chevron_left</mat-icon>
  </button>
  <span class="header-text">{{ headerText }}</span>
</div>